let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("cM9em"), load("fr9NE"), load("h2MrD"), load("bYT2S"), load("hPzOn"), load("8SBrF")]).then(() => parcelRequire('2555l'));